export default {
  notfound: {
    title: 'لم يتم إنشاء هذه الصفحة بعد',
    hint: 'أخبرني المزيد عن هذه الصفحة حتى أتمكن من إنشائها',
  },
};